// These factors are specific to formula fields belonging to ideas. At present some logic / enums are shared with RoadmapFactors to reduce duplication.
export enum CalculationInsightCountFactors {
  companyInsightCount = 'companyInsightCount', // the number of insights but grouped by unique companies
  insightCount = 'insightCount',
  niceToHaveInsightCount = 'niceToHaveInsightCount',
  importantInsightCount = 'importantInsightCount',
  mustHaveInsightCount = 'mustHaveInsightCount',
}

export enum CalculationCompanySpendFactors {
  monthlySpend = 'monthlySpend',
  annualSpend = 'annualSpend',
}

export enum CalculationOpportunityValueFactors {
  totalOpenOpportunityValue = 'totalOpenOpportunityValue',
  totalOpportunityValue = 'totalOpportunityValue',
}

export const AllCalculationFactors = [
  ...Object.values(CalculationInsightCountFactors),
  ...Object.values(CalculationCompanySpendFactors),
  ...Object.values(CalculationOpportunityValueFactors),
];

export type DefaultFactors =
  | CalculationInsightCountFactors
  | CalculationCompanySpendFactors
  | CalculationOpportunityValueFactors;
